import { lazy } from "react";
import pathRoutes from "routes/pathRoutes";

const Login = lazy(() => import("./Pages/Login"));

export const authRoutes = [
  {
    page: Login,
    path: pathRoutes.auth.login,
  },
];
